module.exports = __webpack_public_path__ + "img/person-using-charger.1cd267ba.png";